import { z } from 'zod'

export const SyncAccountStripeResult = z.object({
  account_id: z.number(),
  payment_method_synced: z.boolean(),
  payment_method_id: z.string().optional(),
  subscriptions_created: z.number(),
  subscription_ids: z.array(z.string()),
  subscriptions_skipped: z.number(),
  errors: z.array(z.string())
})

export type SyncAccountStripeResult = z.infer<typeof SyncAccountStripeResult>
